__turbopack_context__.v({
  "className": "sohnemono_cbb7b2c0-module__4kOZ-a__className",
  "variable": "sohnemono_cbb7b2c0-module__4kOZ-a__variable",
});
